<div class="splash" aria-busy="true">
  <div class="splash__inner">
    <bodyanalytics-brand-logo variant="dark" [height]="56" />
    <div class="splash__spinner" aria-hidden="true"></div>
    <div class="splash__status" role="status">{{ status() }}</div>
  </div>
  @if (footer()) {
    <div class="splash__foot" aria-hidden="true">{{ footer() }}</div>
  }
</div>
